import React, { useState } from "react";
import { Card, CardBody, Row, Col, Button, Input, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "react-query";
import { DeleteColumnOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { deleteCompte, getMesCopmtes, updateCompte } from "../../services/merchandApi";
import * as Yup from "yup";
import { useFormik } from "formik";
import NewCompte from "./newCompte";
const MesComptes = ( ) => {
   const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));
  const user = currentUser?.user || {};
  const adminId = user?.id;
  const queryClient = useQueryClient();
  const [editingInfos, setEditingInfos] = useState(false);
  const [selectedCompte, setSelectedCompte] = useState(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [showModalContact, setShowModalContact] = useState(false);
   const {
      data: comptes,
      isLoading: isLoadingAll,
      isError: isErrorAll,
      error: errorAll,
    } = useQuery(["comptes",adminId],()=> getMesCopmtes(adminId), {
       enabled: !!adminId,
    });
     const formikInfos = useFormik({
  initialValues: {
    id: selectedCompte?.id || "",
    ownerFullName: selectedCompte?.ownerFullName || "",
    prefixCode: selectedCompte?.prefixCode || "",
    phoneNumber: selectedCompte?.phoneNumber || "",
  },
 enableReinitialize: true,
  validationSchema: Yup.object({
    ownerFullName: Yup.string().required("Nom du titulaire requis"),
    prefixCode: Yup.string().required("Indication pays requis"),
    phoneNumber: Yup.string().required("Téléphone requis"),
  }),
 onSubmit: async (values) => {
  if (!selectedCompte) return; // sécurité

  setIsLoadingSubmit(true);
  try {
    await updateCompte({
      id: selectedCompte.id,
      payload: {
        ownerFullName: values.ownerFullName,
        prefixCode: values.prefixCode,
        phoneNumber: values.phoneNumber,
        paymentMethod: selectedCompte.paymentMethod,
        countryCode: selectedCompte.countryCode,
        merchantId: selectedCompte.merchantId
      },
    });

    toast.success("Compte mis à jour 🎉");
    queryClient.invalidateQueries(["comptes", adminId]); // rafraîchit la liste
    setEditingInfos(false);
    setSelectedCompte(null);
  } catch (error) {
    toast.error(error?.response?.data?.message || "Erreur lors de la mise à jour");
  } finally {
    setIsLoadingSubmit(false);
  }
},

  enableReinitialize: true,
});
const handleDeleteCompte = async (compteId) => {
  if (!compteId) return;

  const confirmDelete = window.confirm(
    "Voulez-vous vraiment supprimer ce compte ?"
  );
  if (!confirmDelete) return;

  const toastId = toast.loading("Suppression du compte...");

  try {
    await deleteCompte(compteId)

    toast.success(toastId, {
      render: "Compte supprimé avec succès 🗑️",
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });

    queryClient.invalidateQueries(["comptes", adminId]);

    if (selectedCompte?.id === compteId) {
      setSelectedCompte(null);
    }
  } catch (error) {
    toast.update(toastId, {
      render:
        error?.response?.data?.message ||
        "Erreur lors de la suppression du compte",
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
  }
};
  return (
    <Card className="shadow-sm border-0 rounded-lg">
      <CardBody className="p-4">
        <div className="mb-4 " style={{fontSize: '20px',fontFamily: 'Poppins, sans-serif', fontWeight: 500, color: '#212529'}}>Mes comptes</div>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center gap-3">
            <div>
              <div className=" mb-0"style={{fontSize: '15px',fontFamily: 'Poppins, sans-serif', fontWeight: 400, color: '#212529BF'}}>Ajoutez vos comptes de réception de commissions</div>
              <small style={{fontSize: '15px',fontFamily: 'Poppins, sans-serif', fontWeight: 400, color: '#212529BF'}}>(jusqu’à 4 comptes autorisés).</small>
            </div>
          </div>
        </div>
        {isLoadingAll && (
        <div className="text-center my-3">
          <Spinner size="sm" /> Chargement des comptes...
        </div>
      )}

      {/* Error */}
      {isErrorAll && (
        <div className="text-danger text-center my-3">
          {errorAll?.message || "Erreur lors du chargement des comptes"}
        </div>
      )}
     {comptes?.map((compte) => (
  <React.Fragment key={compte.id}>
    <div
      className="mb-3"
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E3E3E3",
          borderRadius: "8px",
          height: "60px",
          overflow: "hidden",
          padding: "0 8px",
          gap: "8px",
        }}
      >
        <img
          src={compte.urlLogo||"/default-logo.png"}
          alt="logo"
          style={{
            width: "31px",
            height: "31px",
            marginRight: "10px",
            objectFit: "contain",
            borderRadius: "50%",
          }}
        />

        <span
          style={{
            flex: "1",
            fontSize: "15px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 500,
            color: "#454545",
          }}
        >
          {compte.paymentMethodName} (+{compte.prefixCode} {compte.phoneNumber})
        </span>

        <button
          type="button"
          onClick={() => setSelectedCompte(compte)}
          style={{
            borderRadius: "20px",
            background: "#E2E8FF",
            color: "#3761FF",
            border: "none",
            padding: "6px 10px",
          }}
        >
          <EditOutlined />
        </button>

        <button
          type="button"
            onClick={() => handleDeleteCompte(compte.id)}
          style={{
            borderRadius: "20px",
            background: "#FFF0F0",
            color: "#D41C1C",
            border: "none",
            padding: "6px 10px",
          }}
        >
      <DeleteOutlined />
      </button>

      </div>
    </div>

    {/* Formulaire inline si ce compte est sélectionné */}
    {selectedCompte?.id === compte.id && (
      <form
        onSubmit={formikInfos.handleSubmit}
        style={{ width: "100%", marginBottom: "16px" }}
      >
        <div className="d-flex gap-2">
          <Input
            name="ownerFullName"
            value={formikInfos.values.ownerFullName}
            onChange={formikInfos.handleChange}
            placeholder="Nom du titulaire"
          />
          <Input
            name="prefixCode"
            value={formikInfos.values.prefixCode}
            onChange={formikInfos.handleChange}
            placeholder="Code pays"
          />
          <Input
            name="phoneNumber"
            value={formikInfos.values.phoneNumber}
            onChange={formikInfos.handleChange}
            placeholder="Téléphone"
          />
          <Button type="submit" style={{border:'#4379F2',backgroundColor:'#4379F2',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}} disabled={isLoadingSubmit}>
            {isLoadingSubmit ? <Spinner size="sm" /> : "Sauvegarder"}
          </Button>
          <Button
          className="me-2"
          style={{border:'#DB2222',backgroundColor:'#DB2222',fontSize: '14px',fontFamily: 'Helvetica, sans-serif', fontWeight: 400, color: '#FFFFFF'}}
            type="button"
            color="secondary"
            onClick={() => setSelectedCompte(null)}
          >
            Annuler
          </Button>
        </div>
      </form>
    )}
  </React.Fragment>
))}
<Button
          type="primary"
           onClick={() => {setShowModalContact(!showModalContact)}}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            backgroundColor: "#3761FF",
            borderColor: "#3761FF",
            borderRadius: "8px",
            fontFamily: "Poppins",
            fontSize: "15px",
            fontWeight: "500",
            padding: "8px 15px",
          }}
        >
          <PlusOutlined/>
          Nouveau compte
        </Button>
      </CardBody>
      {showModalContact && (
        <NewCompte
          show={showModalContact}
          onClose={() => {
            setShowModalContact(false);
          }}
        />
      )}
    </Card>
    
  );
};
export default MesComptes;
